import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '周末到铜梁';
const baseUrl = 'ZMDTL0230';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/weekNews`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'weekNews',
      name: `${baseUrl}-weekNews`,
      component: () => import('./pages/WeekNews.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'townNews',
      name: `${baseUrl}-townNews`,
      component: () => import('./pages/TownNews.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'giftNews',
      name: `${baseUrl}-giftNews`,
      component: () => import('./pages/GiftNews.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
